<template>
  <div v-show="this.$store.state.layout !== 'landing'" class="card card-plain shadow-none" id="sidenavCard">

  </div>
</template>
<script>
import img from "../../assets/img/illustrations/icon-documentation.svg";

export default {
  name: "sidenav-card",
  props: ["textPrimary", "textSecondary", "iconClass"],
  data() {
    return {
      img
    };
  }
};
</script>
